module.exports = __webpack_public_path__ + "static/media/icon_pagination_list_level_1.63737e0f.svg";